import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import './index.css' 
import reportWebVitals from './reportWebVitals'
import {Router, Switch, Route, Redirect} from 'react-router-dom' 
import { AppProvider } from '@contexts'
import {Main} from '@layouts'
import { AuthRoute, UnAuthRoute } from '@routes'
import {SignIn, SignOut, NotFound} from '@views'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
const history = createBrowserHistory()

const muiTheme = createTheme({ 
  // palette: {
  //   // type: 'dark',
  //   primary: {
  //     main: '#ee5e4b',
  //   },
  // },
  // tooltip: {
  //   rippleBackgroundColor: '#fff',
  //   color: 'black',
  // },
})

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={muiTheme}>
      <AppProvider>
        <Router history={history}>    
          <Switch>
            <AuthRoute exact path="/">
              <Redirect to="/main" />
            </AuthRoute>
            <UnAuthRoute path="/signin">
              <SignIn />
            </UnAuthRoute>    
            <AuthRoute path="/signout">
              <SignOut />
            </AuthRoute>
            <AuthRoute path="/main">
              <Main />
            </AuthRoute>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Router> 
      </AppProvider> 
    </MuiThemeProvider> 
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
